module.exports = __webpack_public_path__ + "static/media/bata-2.32d886d8.jpeg";